import { Flex, Group, Stack, Switch, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { EucdmCode, MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { DeclarationViewDV1FormValues } from './DeclarationViewDV1';

interface BuyerFormProps {
  form: UseFormReturnType<DeclarationViewDV1FormValues>;
  editDisabled: boolean;
  declarationGroup?: string;
  isExport?: boolean;
}

export const BuyerForm: React.FC<BuyerFormProps> = ({ form, editDisabled, declarationGroup, isExport }) => {
  const codelistSystems = useCodeListSystem({
    group: declarationGroup,
    isExport,
  });
  return (
    <Stack mb="xl">
      <Flex justify="space-between" align="center">
        <Title order={5} fw={600}>
          Buyer
        </Title>
        <Switch {...form.getInputProps('dv1.buyer.header')} checked={form.values.dv1.buyer.header} label="Header" disabled={editDisabled} size="lg" />
      </Flex>

      <Group grow>
        <EucdmCode path="buyer.name">
          <TextInput {...form.getInputProps('dv1.buyer.name')} label="Name" disabled={editDisabled} />
        </EucdmCode>

        <EucdmCode path="buyer.identificationNumber">
          <TextInput {...form.getInputProps('dv1.buyer.identificationNumber')} label="Identification Number" disabled={editDisabled} />
        </EucdmCode>
      </Group>

      <Group grow>
        <EucdmCode path="buyer.address.street">
          <TextInput {...form.getInputProps('dv1.buyer.address.street')} label="Street" disabled={editDisabled} />
        </EucdmCode>

        <EucdmCode path="buyer.address.postcode">
          <TextInput {...form.getInputProps('dv1.buyer.address.postcode')} label="Postcode" disabled={editDisabled} />
        </EucdmCode>

        <EucdmCode path="buyer.address.city">
          <TextInput {...form.getInputProps('dv1.buyer.address.city')} label="City" disabled={editDisabled} />
        </EucdmCode>

        <EucdmCode path="buyer.address.country">
          <MultiLangCodes {...form.getInputProps('dv1.buyer.address.country')} label="Country" code="CL199" disabled={editDisabled} system={codelistSystems} />
        </EucdmCode>
      </Group>
    </Stack>
  );
};
